export default class ServiceRequest {
    private _xmlHttpRequest: XMLHttpRequest;

    constructor(xmlHttpRequest: XMLHttpRequest) {
        this._xmlHttpRequest = xmlHttpRequest;
    }

    public get isActive(): boolean {
        return this._xmlHttpRequest.readyState != XMLHttpRequest.DONE;
    }

    public tryAbort(): void {
        if (this.isActive) {
            this._xmlHttpRequest.abort();
        }
    }

    public static abort(...request: (ServiceRequest)[]): void {
        request.forEach(r => r && r.tryAbort());
    }
}